import React from 'react';
import { Typography, ListItem, Box } from '@mui/material';

import { useHistory } from 'react-router-dom';

import HomeIcon from '../../assets/HomeIcon';

import { hoverStyleHome } from '../../style';

import { styles } from '../style';
import { MENU_KEYS } from 'constants/constants';

interface Props {
  open: boolean;
  currentImage: string;
  expanded: string | false | null;
  onCleanHover: () => void;
  onChangeHover: (
    e: React.MouseEvent<HTMLLIElement, MouseEvent>,
    text: string,
    menuKey: string | undefined,
  ) => void;
  returnPath: (path: string) => boolean;
  closeDrawer: () => void;
}

const ItemHome = ({
  open,
  expanded,
  currentImage,
  onCleanHover,
  onChangeHover,
  returnPath,
  closeDrawer,
}: Props) => {
  const history = useHistory();

  const goToHome = () => {
    history.push('/');
    closeDrawer();
  };

  return (
    <ListItem
      button
      sx={styles.listItem}
      onClick={goToHome}
      onMouseEnter={(e: any) => onChangeHover(e, 'home', MENU_KEYS.home)}
      onMouseLeave={onCleanHover}
    >
      <Box sx={styles.itemMenu} display="flex">
        <HomeIcon
          open={open}
          currentImage={currentImage}
          isExpanded={String(expanded)}
          disabled={false}
          returnPath={returnPath}
        />
        {open ? (
          <Typography
            sx={[
              open && expanded === false
                ? styles.textItemLight
                : currentImage === MENU_KEYS.home && open
                  ? styles.textItemExpanded
                  : styles.textItemContacted,
              ...(currentImage === MENU_KEYS.home ? [hoverStyleHome] : []),
            ]}
          >
            Home
          </Typography>
        ) : null}
      </Box>
    </ListItem>
  );
};

export default ItemHome;
